import React from "react";
import "./Body.css";
import Standardslide from "../../Components/Standardslide/Standardslide";
import { Container, Row } from "reactstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes, faCheck } from "@fortawesome/free-solid-svg-icons";
library.add(faTimes, faCheck);

export default class Body extends React.Component {

    render() {

        return (
            <Container className="content-wrapper">
                <Row>
                    <Standardslide />

                </Row>
            </Container >
        );
    }
}